<template>
    <div class="EditarProyecto">
        <Menu :sesion="sesion" :url="url" v-if="sesion"/>
        <Submenu :menuActivo="2" :url="url"/>
        
        <div v-show="loading">
            <div class="d-flex justify-content-center mt-5">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <div v-show = "!loading" class="container pt-3">
            
            <router-link to="/Proyectos" class="notLink">
                <font-icon icon="arrow-circle-left"/> Regresar
            </router-link>

            <h1 class="text-center mt-4">Edita tu Proyecto "<b>{{nombreProyecto}}</b>"</h1>
            <hr>
            <form @submit="cambiar">
                    <div class="card-body">
                        <div class="form-group">
                        
                            <h6><b>Nombre del Proyecto</b></h6>
                            <input type="text" class="form-control" v-model="nombreProyecto" placeholder="" required>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4 mb-3">
                                <h6><b>Producto</b></h6>
                                 <select class="form-control" v-model="producto">
                                    <option value="">Seleccione un Producto</option>
                                    <option :value="f.nombre_producto" v-for="f in productos" :key="f.id">{{f.nombre_producto}} </option>
                                </select>
                            </div>
                            <div class="col-4 mb-3">
                                <h6><b>Version</b></h6>
                                <input type="text" class="form-control" maxlength="15" required v-model="version">
                            </div>
                            <div class="col-4 mb-3">
                                <h6><b>Pago por avance</b></h6>
                                <div class="btn-group btn-group-toggle pl-2" data-toggle="buttons">
                                    <label class="btn btn-outline-secondary active">
                                        <input type="radio" name="options" id="option1" @click="toggle('1')" checked> Si
                                    </label>
                                    <label class="btn btn-outline-secondary">
                                        <input type="radio" name="options" id="option2" @click="toggle('0')"> No
                                    </label>
                                </div>
                            </div>

                            <div class="col-3">
                                <h6><b>Fecha de Inicio</b></h6>
                                <input type="date" id="dateInicioProyecto" required class="form-control" v-model="fechaInicio">
                            </div>
                            <div class="col-3">
                                <h6><b>Fecha de Entrega</b></h6>
                                <input type="date" id="dateVigencia" class="form-control" required v-model="fechaFin">
                            </div>
                             <div class="col-6">
                                <h6><b>Idiomas del Proyecto</b></h6>
                                <div class="idiomas row">
                                    <select class="form-control col-5" id="customCheck1" v-model="idioma" required>
                                        <option value="">--Idioma--</option>
                                        <option v-for="f in idiomas" :key="f.id_language" :value="f.language">{{f.language}}</option>
                                    </select>
                                   
                                    <select class="form-control col-5 ml-2" id="customCheck1" v-model="idioma2">
                                        <option value="">--Idioma--</option> 
                                        <option v-for="f in idiomas" :key="f.id_language" :value="f.language">{{f.language}}</option>
                                    </select>
                                </div>
                                
                            </div>
                            
                        </div>
                        <div class="form-group">
                            <h6><b>Explica tu proyecto</b></h6>
                            <small>{{caracteresRestantes}} carácteres restantes (Máximo 4000 carácteres) </small>
                            <textarea class="form-control" rows="5" maxlength="4000" v-model="notaProyecto" required></textarea>
                        </div>

                        <div class="form-group">
                            <h6><b>¿Que conocimiento se requiere?</b>
                                <button type="button" class="btn btn-sm btn-warning" data-toggle='modal' data-target='#criterio-busqueada'>
                                    <font-icon icon="exclamation-triangle"/>
                                </button>
                            </h6>
                            <small>Máximo 3 especialidades</small>
                            <div class="row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="buscar" placeholder="buscar...">
                                    <ul class="list-group pointer">
                                        <li class="list-group-item" v-for="f in resultBusqueda" :key="f.id_modulo" @click="select(f)">
                                            {{f.module_cod}} - {{f.module_name}} 
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-sm-6">
                                    <ul>
                                        <li v-for="x in conocimientos" :key="x.id">
                                            <span class="badge badge-success">
                                                {{x.alias}} - {{x.name}}
                                            </span>
                                            <i class="text-danger pointer" @click="remove(x)">
                                                <font-icon icon="times"/>
                                            </i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <h6><b>¿Tiene algun otro requerimiento sobre la experiencia del consultor?</b></h6>
                            <input  type="text" class="form-control" v-model="notaExperiencia">
                        </div>

                        <div class="form-group pt-2">
                            <h6><b>Adjuntos</b><a class="ml-2" style="font-size: 18px;" href="">{{fileName}}</a></h6>
                            <div class="row">
                                <div class="col-sm-6">
                                    <input type="file" class="form-control" @change="addFile">
                                </div>
                            </div>
                        </div>

                        <div class="text-center pt-3">
                            
                            <div>
                                <button type="submit" class='btn orange'>
                                    Actualizar
                                </button>
                            </div>
                            
                        </div>
                        
                    </div>
                </form>
        </div>

         <div class='modal fade' id='criterio-busqueada' tabindex='-1' role='dialog' aria-labelledby='exampleModalLabel' aria-hidden='true' data-backdrop='static'>
            <div class="modal-dialog modal-xs">
                <div class='modal-content'>

                    <div class='modal-header '>
                            <h6 class='modal-title' id='exampleModalLabel'>
                              <font-icon icon="exclamation-triangle"/>  Criterios para búsqueda
                            </h6>
                            <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
                                <span aria-hidden='true'>&times;</span>
                            </button>
                    </div>
                    <div class='modal-body'>
                        <p>Busca por el nombre de la especialización, no por su nomenclatura.</p>
                        <b>Ejemplo</b>
                        <p class="text-center">Si requieres un consultor <b>"ABAP"</b> <br> 
                            Teclea cualquiera de las palabras de la especialización: <br>
                            <b>Advance Business Application Programming</b>  
                        </p>
                    </div>

                    <div class='modal-footer'>
                        <button type='button' class='btn btn-warning' data-dismiss='modal'>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
import { mapState } from 'vuex'
import { globalFunctions } from '@/hooks/globalFunctions'

import $ from 'jquery'

import Submenu from '@/components/Submenu'
import Menu from '@/components/Menu'

export default {
name:'EditarProyecto',
mixins: [ globalFunctions ],
data(){
    return{
        id: this.$route.params.idProyecto,
        sesion: false,
        resultBusqueda:[],
        botonLoadingHide: true,
        botonLoadingShow: false,
        nombreProyecto:'',
        notaProyecto:'',
        buscar:'',
        conocimientos:[],
        conocimientosAux: [],
        selectedFile: null,
        fileName:'',
        caracteresRestantes:4000,
        producto: 1,
        version: '',
        pagoAvance: '',
        fechaInicio: '',
        fechaFin: '',
        idioma: '',
        idioma2: '',
        notaExperiencia: '',
        check: '',
        loading: true,
        maxDate: '',
        min: '',
        productos:[],
        idiomas:[]
    }
},
components:{
    Submenu,Menu
},
computed:{
    ...mapState(['url'])
},
methods: {
    toggle(opcion){
        this.pagoAvance = opcion;
    },

    getCatalogs(){
        
        this.axios.post(this.url + 'consulta_prod.php').then((responce) =>{
            this.productos = responce.data;
        });

        this.axios.post(this.url + 'consulta_idiomas.php').then((responce) =>{
            this.idiomas = responce.data;
        });
    },

    getProyecto(){
        let data = {
            flag: 5,
            id: this.id,
            id_empresa: localStorage.userID
        }

        this.getCatalogs();

        this.axios.post(this.url + 'getProyectos.php', data).then((responce) =>{
                
                this.nombreProyecto = responce.data[0].titulo_proyecto;
                this.producto = responce.data[0].producto;
                this.version = responce.data[0].version;
                this.pagoAvance = responce.data[0].paga_avances;
                this.fechaInicio = responce.data[0].fecha_inicio;
                this.fechaFin = responce.data[0].fecha_cierre;
                this.notaProyecto = responce.data[0].cuerpo;
                this.notaExperiencia = responce.data[0].notaExperiencia;
                this.fileName = responce.data[0].adjunto;
                this.idioma = responce.data[0].idioma;
                this.idioma2 = responce.data[0].idioma_dos;
                
                if(this.fileName != null){
                     ///poner que se vea el archivo
                }
                if(responce.data[0].esp1 != ""){
                    
                    this.getConocimiento(responce.data[0].esp1,2);

                }
                if(responce.data[0].esp2 != ""){
                    this.getConocimiento(responce.data[0].esp2,2);
                }
                if(responce.data[0].esp3 != ""){
                    this.getConocimiento(responce.data[0].esp3,2);
                }

                this.loading = false;

                if(this.maxDate > this.fechaInicio){
                    this.fechaInicio = ''
                }

                if(this.min > this.fechaFin){
                    this.fechaFin = ''
                }

        });
    },
    getConocimiento(param,flags){

        if(param.length <= 0) //Salir al ser menor a 2
        {
            this.resultBusqueda = [];
            return;
        }

        let data = {
            query:param,
            flag:flags
        };
        
        this.axios.post(this.url + 'consultasBasicas.php', data).then((responce) =>{
            this.resultBusqueda = responce.data;
           if(flags == 2){
                this.resultBusqueda.forEach(element => {
                this.select(element);
            });
           }
        });
    },
    select(f){
        let long = this.conocimientos.length;

        const data = {
            id:f.id_modulo,
            alias:f.module_cod,
            name:f.module_name,
        }
        
        if(long >= 3){
            this.msjError('Solo se permiten 3 valores');
            
            this.resultBusqueda = [];
            this.buscar = "";
            return;
        }
        else{
            this.conocimientos.push(data);
            this.resultBusqueda = [];
            this.buscar = "";
        }
    },
    remove(x){
        let index = this.conocimientos.indexOf(x);
        this.$delete(this.conocimientos,index);
    },
    cambiar(e){
        e.preventDefault();
        
         if(this.conocimientos.length <= 0){
            alert("Faltan conocimientos");
            return;
        }
 
        let data = {
           flag: 1,
            nombre:this.nombreProyecto,
            cuerpo: this.notaProyecto,
            conocimientos: this.conocimientos,
            id: this.id,
            fileName: this.fileName,
            producto: this.producto,
            version: this.version,
            pagoAvance: this.pagoAvance,
            fechaInicio: this.fechaInicio,
            fechaFin: this.fechaFin,
            idioma: this.idioma,
            idioma2: this.idioma2,
            notaExperiencia: this.notaExperiencia
        }
        
         this.axios.post(this.url + 'updateProyecto.php', data).then((responce) =>{
            //console.log('cambiar',responce.data);
            if(responce.data == '200'){
                if(this.selectedFile != null && this.selectedFile != '')
                {
                    //console.log(this.selectedFile)
                    const fd = new FormData();
                    fd.append('file',this.selectedFile, this.selectedFile.name);

                    this.axios.post(this.url + 'altaArchivo.php', fd, {
                        header:{
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((responce) =>{
                        //console.log('responce alta Archivo',responce);
                        if(responce.data.res == '200'){
                            
                            let data = {
                                flag: 0,
                                id: this.id,
                                fileName: responce.data.nombre
                            }
                            
                            this.axios.post(this.url + 'altaFile.php', data).then((responce) =>{
                                if(responce.data == '200'){
                                    this.$router.push('/Proyectos');
                                }else{
                                    this.msjError(responce.data);
                                }
                            });
                            
                        }else{
                            this.msjError(responce.data.res);
                        }
                    });
                }else{
                    this.$router.push('/Proyectos');
                }
            }else{
                this.msjError(responce.data);
            }
            

        });

    },
    addFile(event){
            this.selectedFile = event.target.files[0];
            //console.log("target", event.target.files[0]);
            this.fileName = this.selectedFile.name;
    },
    subirImage(){            
                    
            if(this.selectedFile != null)
            {
                const fd = new FormData();
                fd.append('file',this.selectedFile, this.selectedFile.name);

                this.axios.post(this.url + 'altaArchivo.php', fd, {
                    header:{
                        'Content-Type': 'multipart/form-data'
                    }
                }).then((responce) =>{
                    if(responce.data == '200'){
                        
                        let data = {
                            id: this.id,
                            fileName: this.fileName
                        }
                        
                        this.axios.post(this.url + 'altaFile.php', data).then((responce) =>{
                            if(responce.data == 200){
                                this.msjOk();
                            }
                        });
                        
                    }else{
                        this.msjError(responce.data);
                    }
                });
            }
        
        }
},
watch:{
    buscar(){
        this.getConocimiento(this.buscar,0);
    }
},
mounted(){
    this.rol =  localStorage.rol;

        //Verificar que el token sigue vivo
        const token = localStorage.token;
        const UserName = localStorage.userID;
        const tabla = localStorage.tabla;
        
        let resp = this.checkUser();
        this.sesion = resp;

    this.getProyecto();

    this.maxDate = this.addFiveDaysToday();
    $('#dateInicioProyecto').attr('min', this.maxDate);

    this.min = this.addDaysToday();
    $('#dateVigencia').attr('min', this.min);
    
}
}
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/EditarProyecto/EditarProyecto.vue